import { defineBlock } from "eddev/blocks"
import { Container, Grid, Col } from "@components/layout/Grid"
import { CardMoreInfo } from "@components/molecules/Cards"
import { useMemo } from "react"

export const meta: BlockMeta = {
  title: "Next page",
  category: "common",
  icon: "align-pull-right",
  keywords: ["next"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("general/next-page", (props) => {
  const ancestor = useMemo(() => {
    if (props?.nextPage?.ancestors?.nodes[0].__typename === "Page") {
      return {
        uri: props.nextPage.ancestors.nodes[0].uri!,
        title: props.nextPage.ancestors.nodes[0].title!,
      }
    }

    return undefined
  }, [props])

  return (
    <Container>
      <Grid>
        <Col initial={12}>
          {props.nextPage && (
            <CardMoreInfo
              type="sibling"
              ancestor={ancestor}
              title={props.nextPage.title!}
              heading={props.nextPage.nextHeading ?? undefined}
              content={props.nextPage.nextContent ?? undefined}
              image={props.nextPage.nextHeroimage ?? undefined}
              link={props.nextPage.uri!}
            />
          )}
        </Col>
      </Grid>
    </Container>
  )
})
